import type { PageUISection, PageUITrailResultSection } from '@alltrails/layout/utils/PageUI/pageUI';
import type { TrailResult } from '../redux/reducer';

export const toTrailResult = (section: PageUITrailResultSection): TrailResult => ({
  type: 'trail',
  id: String(section.trailId),
  ID: section.trailId, // numeric; polylines are fetched by it
  objectID: `trail-${section.trailId}`,
  name: section.name,
  slug: section.slug,
  _geoloc: section._geoloc,
  location_label: section.locationLabel,
  avg_rating: section.avgRating,
  difficulty_rating: String(section.difficultyRating),
  length: section.length,
  duration_minutes: section.durationMinutes,
  num_reviews: section.numReviews,
  is_closed: section.isClosed,
  profile_photo_url: section.profilePhoto?.url
});

/**
 * The map half of PageUI: one switch over the same section union the sidebar renders, building the TrailResult[] that
 * TrailResults already draws. A section type that has nothing to put on the map returns [].
 */
export const sectionToTrailResults = (section: PageUISection): TrailResult[] => {
  switch (section.sectionType) {
    case 'trail-result':
      // Typed as required, but a trail without a trailhead can't be pinned or framed, so it is dropped
      return section._geoloc ? [toTrailResult(section)] : [];
    default:
      return [];
  }
};

/**
 * Every pin a response puts on the map, ranked by its index in the server's order: `popularity` drives the pins' sort key, so
 * each pin needs its own for overlapping pins to draw one at a time.
 */
export const sectionsToTrailResults = (sections: PageUISection[]): TrailResult[] => {
  const results = sections.flatMap(sectionToTrailResults);

  return results.map((result, index) => ({ ...result, popularity: results.length - index }));
};
